(function () {
  if (window.EmpirePG) return;

  function suppressPageScroll(duration = 900) {
    const x = window.scrollX,
      y = window.scrollY;
    const origScrollTo = window.scrollTo;
    const origScrollBy = window.scrollBy;
    const origIntoView = Element.prototype.scrollIntoView;
    const origFocus = HTMLElement.prototype.focus;

    window.scrollTo = function () {};
    window.scrollBy = function () {};
    Element.prototype.scrollIntoView = function () {};
    HTMLElement.prototype.focus = function (opts) {
      try {
        origFocus.call(this, { preventScroll: true });
      } catch (e) {
        origFocus.call(this);
      }
    };

    const html = document.documentElement;
    const prevBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";

    const restore = () => {
      window.scrollTo = origScrollTo;
      window.scrollBy = origScrollBy;
      Element.prototype.scrollIntoView = origIntoView;
      HTMLElement.prototype.focus = origFocus;
      html.style.scrollBehavior = prevBehavior;
      window.scrollTo(x, y);
    };

    setTimeout(() => {
      requestAnimationFrame(() => requestAnimationFrame(restore));
    }, duration);
  }

  if (!window.__empireGalleryFadeCSS) {
    window.__empireGalleryFadeCSS = true;
    const style = document.createElement("style");
    style.textContent = `
    [data-gallery-viewer].pg-fade [data-gallery-figure] {
      transition: opacity .5s cubic-bezier(.4,0,.2,1);
      opacity: 0;
      position: absolute;
      left: 0; top: 0; width: 100%; height: 100%;
      pointer-events: none;
    }
    [data-gallery-viewer].pg-fade [data-gallery-figure][data-gallery-selected="true"] {
      opacity: 1;
      position: relative;
      pointer-events: auto;
      z-index: 1;
    }
    [data-gallery-viewer].pg-fade [data-gallery-figure][data-gallery-secondary="true"] {
      opacity: 1;
      position: relative;
      pointer-events: auto;
      z-index: 0;
    }
    .product-gallery[data-product-gallery-dual] [data-gallery-viewer]:not(.flickity-enabled) [data-gallery-figure][data-gallery-secondary="true"] {
      visibility: visible;
      opacity: 1;
    }

      @media (max-width: 767px) {
      .product-gallery--navigation[data-gallery-navigation] .gallery-navigation--scroll-button,
      .product-gallery--navigation[data-gallery-navigation] [data-gallery-scroll-button] {
        display: none !important;
      }
      .template-product .product-gallery--navigation {
        min-height: 0;
      }
      .product-gallery--navigation[data-gallery-navigation] .gallery-navigation--scroller {
        margin-inline: 0 !important;
        padding-inline: 0 !important;
      }
    }
  `;
    document.head.appendChild(style);
  }

  function goTo(root, i, { suppressScroll = true } = {}) {
    const THUMB_SEL = "[data-gallery-thumbnail]";
    const btn = root.querySelector(`${THUMB_SEL}[data-gallery-index="${i}"]`);
    if (!btn) return false;

    let x = window.scrollX,
      y = window.scrollY;
    const origScrollTo = window.scrollTo;
    const origScrollBy = window.scrollBy;
    const origIntoView = Element.prototype.scrollIntoView;
    const origFocus = HTMLElement.prototype.focus;
    window.scrollTo = function () {};
    window.scrollBy = function () {};
    Element.prototype.scrollIntoView = function () {};
    HTMLElement.prototype.focus = function (opts) {};
    btn.click();
    setTimeout(() => {
      window.scrollTo = origScrollTo;
      window.scrollBy = origScrollBy;
      Element.prototype.scrollIntoView = origIntoView;
      HTMLElement.prototype.focus = origFocus;
      window.scrollTo(x, y);
      const figs = root.querySelectorAll("[data-gallery-figure]");
      figs.forEach((fig, idx) => {
        if (idx === i) {
          fig.setAttribute("data-gallery-selected", "true");
        } else {
          fig.removeAttribute("data-gallery-selected");
        }
      });
    }, 10);
    return true;
  }

  window.EmpirePG = { goTo, suppressPageScroll };
})();

(() => {
  const ROOT_SEL = ".product-gallery[data-product-gallery]";
  const VIEWER_SEL = "[data-gallery-viewer]";
  const THUMB_SEL = "[data-gallery-thumbnail]";
  const FIG_SEL = "[data-gallery-figure]";

  const prefersReduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const num = (el) => parseInt(el?.getAttribute("data-gallery-index"), 10);
  const mediaType = (el) =>
    (el?.getAttribute("data-media-type") || "").toLowerCase();
  const isVideoThumb = (el) => mediaType(el) === "video";
  const isVideoFigure = (el) => mediaType(el) === "video";

  function getThumbs(root) {
    const thumbs = Array.from(root.querySelectorAll(THUMB_SEL));
    thumbs.sort((a, b) => (num(a) || 0) - (num(b) || 0));
    return thumbs.filter((t) => t.offsetParent !== null);
  }
  function getFigures(root) {
    const figs = Array.from(root.querySelectorAll(FIG_SEL));
    figs.sort((a, b) => (num(a) || 0) - (num(b) || 0));
    return figs;
  }
  function getActiveIndex(root) {
    const activeThumb = root.querySelector(
      `${THUMB_SEL}[data-gallery-selected="true"]`
    );
    if (activeThumb) {
      const i = num(activeThumb);
      if (Number.isFinite(i)) return i;
    }
    const activeFig = root.querySelector(
      `${FIG_SEL}[data-gallery-selected="true"]`
    );
    if (activeFig) {
      const i = num(activeFig);
      if (Number.isFinite(i)) return i;
    }
    return 0;
  }
  function nextIndex(root, skipVideo = true) {
    const thumbs = getThumbs(root);
    if (!thumbs.length) return null;
    let i = getActiveIndex(root);
    for (let step = 1; step <= thumbs.length; step++) {
      const cand = (i + step) % thumbs.length;
      if (!skipVideo) return cand;
      const t = root.querySelector(
        `${THUMB_SEL}[data-gallery-index="${cand}"]`
      );
      if (t && !isVideoThumb(t)) return cand;
    }
    return (i + 1) % thumbs.length;
  }
  function prevIndex(root, skipVideo = true) {
    const thumbs = getThumbs(root);
    if (!thumbs.length) return null;
    let i = getActiveIndex(root);
    for (let step = 1; step <= thumbs.length; step++) {
      const cand = (i - step + thumbs.length) % thumbs.length;
      if (!skipVideo) return cand;
      const t = root.querySelector(
        `${THUMB_SEL}[data-gallery-index="${cand}"]`
      );
      if (t && !isVideoThumb(t)) return cand;
    }
    return (i - 1 + thumbs.length) % thumbs.length;
  }

  function buildArrows(root, { pause, resume, interval, skipVideo }) {
    const viewer = root.querySelector(VIEWER_SEL) || root;
    if (!viewer || viewer.querySelector(".pg-arrows")) return;

    const wrap = document.createElement("div");
    wrap.className = "pg-arrows";

    const mkBtn = (dir) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "pg-arrow";
      b.setAttribute(
        "aria-label",
        dir === "prev" ? "Previous image" : "Next image"
      );
      b.innerHTML =
        dir === "prev"
          ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      b.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        pause();

        const target =
          dir === "prev"
            ? prevIndex(root, skipVideo)
            : nextIndex(root, skipVideo);
        if (target !== null)
          EmpirePG.goTo(root, target, { suppressScroll: true });

        if (!viewer.matches(":hover")) {
          setTimeout(resume, interval);
        }
      });
      return b;
    };

    wrap.appendChild(mkBtn("prev"));
    wrap.appendChild(mkBtn("next"));
    viewer.appendChild(wrap);
  }

  function attachHoverTracker(root, setHoverPaused) {
    const viewer = root.querySelector(VIEWER_SEL) || root;
    if (!viewer) return;

    let rect = viewer.getBoundingClientRect();
    let rafFlag = false;
    let inside = false;

    const recompute = () => {
      rect = viewer.getBoundingClientRect();
    };

    const within = (x, y) =>
      x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

    function onPointerMove(e) {
      if (rafFlag) return;
      rafFlag = true;
      requestAnimationFrame(() => {
        rafFlag = false;
        rect = viewer.getBoundingClientRect();
        const now = within(e.clientX, e.clientY);
        if (now !== inside) {
          inside = now;
          setHoverPaused(inside);
        }
      });
    }

    function onDocScroll() {
      if (!inside) return;
      rect = viewer.getBoundingClientRect();
      const cx = window.innerWidth / 2,
        cy = window.innerHeight / 2;
      const now = within(cx, cy);
      if (now !== inside) {
        inside = now;
        setHoverPaused(inside);
      }
    }

    document.addEventListener("pointermove", onPointerMove, { passive: true });
    document.addEventListener("scroll", onDocScroll, { passive: true });
    window.addEventListener("resize", () => requestAnimationFrame(recompute), {
      passive: true,
    });

    viewer.addEventListener(
      "mouseenter",
      () => {
        inside = true;
        setHoverPaused(true);
      },
      { passive: true }
    );
    viewer.addEventListener(
      "mouseleave",
      () => {
        inside = false;
        setHoverPaused(false);
      },
      { passive: true }
    );
  }

  function setup(root) {
    if (root.__empireAutoPlay) return;
    root.__empireAutoPlay = true;
    if (prefersReduced) return;

    const viewer = root.querySelector(VIEWER_SEL) || root;

    const scroller = root.querySelector("[data-gallery-scroller]") || viewer;

    const isSwipeMode = () => {
      return scroller.scrollWidth - scroller.clientWidth > 8;
    };

    const applyFadeMode = () => {
      if (isSwipeMode()) viewer.classList.remove("pg-fade");
      else viewer.classList.add("pg-fade");
    };

    applyFadeMode();
    new ResizeObserver(applyFadeMode).observe(scroller);
    new MutationObserver(applyFadeMode).observe(root, {
      childList: true,
      subtree: true,
    });

    const autoplay =
      (root.getAttribute("data-gallery-autoplay") || "true") === "true";
    let interval = parseInt(root.getAttribute("data-gallery-interval"), 10);
    if (!Number.isFinite(interval) || interval <= 0) interval = 8000;
    const pauseOnHover =
      (root.getAttribute("data-gallery-pause-on-hover") || "true") === "true";
    const skipVideo =
      (root.getAttribute("data-gallery-skip-video") || "true") === "true";

    let timer = null;

    const isHoverPaused = () => root.dataset.hoverPaused === "1";
    const setHoverPaused = (v) => {
      if (v) {
        root.dataset.hoverPaused = "1";
        root.setAttribute("data-gallery-hover", "1");
      } else {
        delete root.dataset.hoverPaused;
        root.removeAttribute("data-gallery-hover");
      }
    };

    const advance = () => {
      if (isHoverPaused()) return;
      const thumbs = getThumbs(root);
      if (thumbs.length <= 1) return;

      if (skipVideo) {
        const figs = getFigures(root);
        const activeFig = figs.find(
          (f) => f.getAttribute("data-gallery-selected") === "true"
        );
        if (activeFig && isVideoFigure(activeFig)) {
          const ni = nextIndex(root, skipVideo);
          if (ni !== null) EmpirePG.goTo(root, ni, { suppressScroll: true });
          return;
        }
      }
      const ni = nextIndex(root, skipVideo);
      if (ni !== null) EmpirePG.goTo(root, ni, { suppressScroll: true });
    };

    const start = () => {
      if (autoplay && !timer) timer = setInterval(advance, interval);
    };
    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? start() : stop()));
      },
      { threshold: 0.35 }
    );
    io.observe(root);

    if (pauseOnHover) attachHoverTracker(root, setHoverPaused);

    root.addEventListener(
      "click",
      (e) => {
        const t = e.target.closest?.(THUMB_SEL);
        if (t) {
          const viewer = root.querySelector(VIEWER_SEL) || root;
          if (!viewer.matches(":hover")) {
            setHoverPaused(false);
          }
        }
      },
      true
    );

    buildArrows(root, {
      pause: () => setHoverPaused(true),
      resume: () => setHoverPaused(false),
      interval,
      skipVideo,
    });

    const mo = new MutationObserver(() => {
      const visible = root.offsetParent !== null;
      const count = root.querySelectorAll(THUMB_SEL).length;
      if (!visible || count <= 1) stop();
    });
    mo.observe(root, { childList: true, subtree: true });

    const r = root.getBoundingClientRect?.();
    const vh = Math.max(
      document.documentElement.clientHeight,
      innerHeight || 0
    );
    if (!r || (r.top < vh && r.bottom > 0)) start();
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(setup);
  }
  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();

(() => {
  const ROOT_SEL = ".product-gallery[data-product-gallery]";
  const VIEWER_SEL = "[data-gallery-viewer]";
  const FIG_SEL = "[data-gallery-figure]";
  const THUMB_SEL = "[data-gallery-thumbnail]";
  const toIndex = (el) => parseInt(el?.getAttribute("data-gallery-index"), 10);

  function buildDots(root) {
    const viewer = root.querySelector(VIEWER_SEL);
    if (!viewer) return;

    let dots = viewer.querySelector(".pg-dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "pg-dots";
      viewer.appendChild(dots);
    }

    const figs = [...viewer.querySelectorAll(FIG_SEL)].sort(
      (a, b) => (toIndex(a) || 0) - (toIndex(b) || 0)
    );

    if (dots.childElementCount !== figs.length) {
      dots.innerHTML = "";
      figs.forEach((fig) => {
        const i = toIndex(fig);
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pg-dot";
        btn.dataset.index = i;
        btn.setAttribute("aria-label", `Image ${i + 1} of ${figs.length}`);
        btn.addEventListener("click", () =>
          EmpirePG.goTo(root, i, { suppressScroll: true })
        );
        dots.appendChild(btn);
      });
    }

    const activeFig = viewer.querySelector(
      `${FIG_SEL}[data-gallery-selected="true"]`
    );
    const ai = activeFig ? toIndex(activeFig) : 0;
    dots.querySelectorAll(".pg-dot").forEach((dot) => {
      if (parseInt(dot.dataset.index, 10) === ai)
        dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
  }

  function setup(root) {
    if (root.__dotsInited) return;
    root.__dotsInited = true;

    buildDots(root);

    const viewer = root.querySelector(VIEWER_SEL);
    const mo = new MutationObserver((muts) => {
      let repaint = false,
        rebuild = false;
      for (const m of muts) {
        if (
          m.type === "attributes" &&
          m.attributeName === "data-gallery-selected"
        )
          repaint = true;
        if (m.type === "childList") rebuild = true;
      }
      if (rebuild) buildDots(root);
      else if (repaint) buildDots(root);
    });
    if (viewer)
      mo.observe(viewer, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["data-gallery-selected"],
      });

    root.addEventListener(
      "click",
      (e) => {
        if (e.target.closest?.(THUMB_SEL)) setTimeout(() => buildDots(root), 0);
      },
      true
    );
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(setup);
  }
  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();

(() => {
  const ROOT_SEL = ".product-gallery[data-product-gallery][data-product-gallery-dual]";
  const VIEWER_SEL = "[data-gallery-viewer]";
  const FIG_SEL = "[data-gallery-figure]";
  const THUMB_SEL = "[data-gallery-thumbnail]";
  const DUAL_MQ = matchMedia("(min-width: 750px)");

  function sortedFigures(viewer) {
    return Array.from(viewer.querySelectorAll(FIG_SEL)).sort(
      (a, b) =>
        (parseInt(a.getAttribute("data-gallery-index"), 10) || 0) -
        (parseInt(b.getAttribute("data-gallery-index"), 10) || 0)
    );
  }

  function syncDualGallery(root) {
    const viewer = root.querySelector(VIEWER_SEL);
    if (!viewer) return;

    const figs = sortedFigures(viewer);
    figs.forEach((fig) => fig.removeAttribute("data-gallery-secondary"));

    const isMobileCarousel = viewer.classList.contains("flickity-enabled");
    if (!DUAL_MQ.matches || isMobileCarousel) return;

    const thumb = root.querySelector(`${THUMB_SEL}[data-gallery-selected="true"]`);
    const activeFig = viewer.querySelector(`${FIG_SEL}[data-gallery-selected="true"]`);
    let idx = thumb
      ? parseInt(thumb.getAttribute("data-gallery-index"), 10)
      : activeFig
        ? parseInt(activeFig.getAttribute("data-gallery-index"), 10)
        : 0;
    if (!Number.isFinite(idx)) idx = 0;

    const secondary = figs[idx + 1];
    if (secondary) {
      secondary.setAttribute("data-gallery-secondary", "true");
      secondary.setAttribute("aria-hidden", "false");
    }
  }

  function initDual(root) {
    if (root.__dualGallerySync) return;
    root.__dualGallerySync = true;

    const viewer = root.querySelector(VIEWER_SEL);
    const run = () => requestAnimationFrame(() => syncDualGallery(root));

    run();

    const mo = new MutationObserver(run);
    mo.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ["data-gallery-selected"],
    });
    if (viewer) {
      mo.observe(viewer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    DUAL_MQ.addEventListener
      ? DUAL_MQ.addEventListener("change", run)
      : DUAL_MQ.addListener(run);
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(initDual);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();

(() => {
  const ROOT_SEL = ".product-gallery[data-product-gallery]";
  const VIDEO_SEL = `${ROOT_SEL} [data-gallery-figure][data-media-type="video"] video`;

  function normalizeVideo(v) {
    if (!v) return;
    v.muted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.autoplay = true;
    v.setAttribute("autoplay", "");
    v.loop = true;
    v.setAttribute("loop", "");
    const p = v.play?.();
    if (p && typeof p.then === "function") p.catch(() => {});
  }

  function init(ctx) {
    if (!ctx || typeof ctx.querySelectorAll !== 'function') {
      ctx = document;
    }
    ctx.querySelectorAll(VIDEO_SEL).forEach(normalizeVideo);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes || []) {
        if (!(n instanceof Element)) continue;
        if (n.matches?.(VIDEO_SEL)) normalizeVideo(n);
        n.querySelectorAll?.(VIDEO_SEL).forEach(normalizeVideo);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const id = 'empirepg-arrows-style';
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = `
    [data-gallery-viewer] .pg-arrows{
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
      transition: opacity .2s ease;
      z-index: 3;
    }

    [data-product-gallery][data-gallery-hover="1"] [data-gallery-viewer] .pg-arrows,
    [data-gallery-viewer]:hover .pg-arrows{
      opacity: 1;
      visibility: visible;
      pointer-events: none;
    }

    .pg-arrows .pg-arrow{
      pointer-events: auto;
      display: grid;
      place-items: center;
      width: 44px;
      height: 44px;
      border-radius: 9999px;
      border: 0;
      background: rgba(0,0,0,.35);
      color: #fff;
      cursor: pointer;
      outline: none;
      transition: transform .15s ease, background .15s ease;
    }
    .pg-arrows .pg-arrow:hover{ transform: scale(1.06); background: rgba(0,0,0,.45); }

    .pg-arrows .pg-arrow:first-child{ margin-left: 8px; }
    .pg-arrows .pg-arrow:last-child{  margin-right: 8px; }

    @media (hover: none), (max-width: 767px){
      [data-gallery-viewer] .pg-arrows{
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: none !important;
      }
      .pg-arrows .pg-arrow{
        width: 40px; height: 40px;
        background: rgba(0,0,0,.30);
      }
    }
  `;
  document.head.appendChild(style);
})();

(() => {
  const MQ_DESKTOP = matchMedia('(min-width:750px)');
  const ROOT_SEL   = '.product-gallery[data-product-gallery]';
  const NAV_SEL    = '[data-gallery-navigation]';
  const SCROLLER   = '.gallery-navigation--scroller';
  const THUMB_SEL  = '[data-gallery-thumbnail]';
  const FIG_SEL    = '[data-gallery-figure]';

  const toIdx = el => parseInt(el?.getAttribute('data-gallery-index'), 10);

  function getActiveIndex(root){
    const aThumb = root.querySelector(`${THUMB_SEL}[data-gallery-selected="true"]`);
    if (aThumb) return toIdx(aThumb);
    const aFig = root.querySelector(`${FIG_SEL}[data-gallery-selected="true"]`);
    return aFig ? toIdx(aFig) : 0;
  }

  function centerThumb(root, idx){
    if (!MQ_DESKTOP.matches) return; 
    const nav = root.querySelector(NAV_SEL);
    const scroller = nav?.querySelector(SCROLLER) || nav;
    if (!scroller) return;

    const thumb = nav.querySelector(`${THUMB_SEL}[data-gallery-index="${idx}"]`);
    if (!thumb) return;

    const sRect = scroller.getBoundingClientRect();
    const tRect = thumb.getBoundingClientRect();

    const above = tRect.top < sRect.top;
    const below = tRect.bottom > sRect.bottom;

    if (above || below){
      const target = thumb.offsetTop - (scroller.clientHeight/2 - thumb.offsetHeight/2);
      scroller.scrollTop = Math.max(0, Math.min(target, scroller.scrollHeight - scroller.clientHeight));
    }
  }

  function initOne(root){
    if (root.__thumbFollowInited) return;
    root.__thumbFollowInited = true;

    requestAnimationFrame(() => centerThumb(root, getActiveIndex(root)));

    const mo = new MutationObserver(() => {
      requestAnimationFrame(() => centerThumb(root, getActiveIndex(root)));
    });
    mo.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-gallery-selected']
    });

    root.addEventListener('click', e => {
      const t = e.target.closest?.(THUMB_SEL);
      if (!t) return;
      const idx = toIdx(t);
      requestAnimationFrame(() => centerThumb(root, idx));
    });

    const onChange = () => requestAnimationFrame(() => centerThumb(root, getActiveIndex(root)));
    window.addEventListener('resize', onChange, {passive:true});
    MQ_DESKTOP.addEventListener ? MQ_DESKTOP.addEventListener('change', onChange)
                                : MQ_DESKTOP.addListener(onChange);
  }

  function init(){
    document.querySelectorAll(ROOT_SEL).forEach(initOne);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

(() => {
  const ROOT_SEL   = '.product-gallery[data-product-gallery]';
  const VIEWER_SEL = '[data-gallery-viewer]';
  const FIG_SEL    = '[data-gallery-figure]';
  const MQ_DESKTOP = matchMedia('(min-width: 768px)');
  const DUAL_HEIGHT_MQ = matchMedia('(min-width: 750px)');

  const $   = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => Array.from(c.querySelectorAll(s));
  const getViewer = r => $(VIEWER_SEL, r) || r;
  const getActive = r => $(`${FIG_SEL}[data-gallery-selected="true"]`, getViewer(r));

  function whenReady(media){
    return new Promise(res => {
      if (!media) return res();
      if (media.tagName === 'IMG') {
        if (media.complete && media.naturalWidth) return res();
        if (media.decode) media.decode().then(res).catch(res);
        else media.addEventListener('load', res, {once:true});
      } else if (media.tagName === 'VIDEO') {
        if (media.readyState >= 2) return res();
        media.addEventListener('loadedmetadata', res, {once:true});
      } else {
        res();
      }
    });
  }

  function expectedHeight(fig){
    const w = fig.clientWidth || fig.getBoundingClientRect().width || 0;
    if (!w) return 0;
    const picImg = $('picture img', fig);
    if (picImg && picImg.naturalWidth) return Math.round(w * picImg.naturalHeight / picImg.naturalWidth);
    const img = $('img', fig);
    if (img && img.naturalWidth)       return Math.round(w * img.naturalHeight  / img.naturalWidth);
    const video = $('video', fig);
    if (video && video.videoWidth)      return Math.round(w * video.videoHeight / video.videoWidth);
    return Math.max(fig.scrollHeight, fig.offsetHeight, 0);
  }

  async function adjust(root){
    if (!MQ_DESKTOP.matches) return;
    const viewer = getViewer(root);
    if (!viewer || !viewer.classList.contains('pg-fade')) { if (viewer) viewer.style.height=''; return; }

    const active = getActive(root);
    if (!active) return;

    const dualPair =
      root.matches('[data-product-gallery-dual]') &&
      DUAL_HEIGHT_MQ.matches &&
      !viewer.classList.contains('flickity-enabled');
    const secondary = dualPair
      ? $(`${FIG_SEL}[data-gallery-secondary="true"]`, viewer)
      : null;

    const prevH = viewer.clientHeight || viewer.getBoundingClientRect().height || 0;
    if (prevH) viewer.style.height = prevH + 'px';

    const media = $('picture img, img, video', active);
    await whenReady(media);
    if (secondary) {
      const media2 = $('picture img, img, video', secondary);
      await whenReady(media2);
    }

    let h = expectedHeight(active);
    if (secondary) h = Math.max(h, expectedHeight(secondary));
    if (!h) { viewer.style.height = 'auto'; return; }

    if (!viewer.style.transition.includes('height')) {
      viewer.style.transition = (viewer.style.transition ? viewer.style.transition + ',' : '') + 'height .25s ease';
    }

    requestAnimationFrame(() => {
      viewer.style.height = h + 'px';
      const release = () => { viewer.style.height = 'auto'; viewer.removeEventListener('transitionend', release); };
      viewer.addEventListener('transitionend', release);
      setTimeout(release, 400);
    });
  }

  function makeController(root){
    const viewer = getViewer(root);
    let mo = null, ro = null;
    const onResize = () => requestAnimationFrame(() => adjust(root));

    function start(){
      if (mo) return;
      mo = new MutationObserver(muts => {
        if (muts.some(m => m.type === 'attributes' && m.attributeName === 'data-gallery-selected')) {
          requestAnimationFrame(() => requestAnimationFrame(() => adjust(root)));
        }
      });
      mo.observe(viewer, {subtree:true, attributes:true, attributeFilter:['data-gallery-selected']});
      ro = new ResizeObserver(() => adjust(root));
      ro.observe(viewer);
      window.addEventListener('resize', onResize, {passive:true});
      window.addEventListener('orientationchange', onResize, {passive:true});
      adjust(root);
    }

    function stop(){
      if (mo){ mo.disconnect(); mo = null; }
      if (ro){ ro.disconnect(); ro = null; }
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      if (viewer) viewer.style.height = '';
    }

    return { start, stop };
  }

  const controllers = new WeakMap();

  function syncAll(){
    qsa(ROOT_SEL).forEach(root => {
      let ctl = controllers.get(root);
      if (!ctl){ ctl = makeController(root); controllers.set(root, ctl); }
      if (MQ_DESKTOP.matches) ctl.start(); else ctl.stop();
    });
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  if (MQ_DESKTOP.addEventListener) MQ_DESKTOP.addEventListener('change', syncAll);
  else MQ_DESKTOP.addListener(syncAll);
})();

(() => {
  const ROOT_SEL = ".product-gallery[data-product-gallery]";
  const VIEWER_SEL = "[data-gallery-viewer]";
  const FIG_SEL = "[data-gallery-figure]";
  const EXPAND_SEL = "[data-gallery-expand]";
  const IGNORE_SEL =
    ".pg-arrow, .pg-arrows, .pg-dots, .pg-dot, [data-shopify-xr], .plyr__control";

  function visibleFigures(viewer) {
    const figs = [...viewer.querySelectorAll(FIG_SEL)];
    if (viewer.classList.contains("flickity-enabled")) {
      return figs.filter((f) => f.classList.contains("is-selected"));
    }
    return figs.filter(
      (f) =>
        f.getAttribute("data-gallery-selected") === "true" ||
        f.getAttribute("data-gallery-secondary") === "true"
    );
  }

  function figureAtPoint(viewer, x, y) {
    const hits = visibleFigures(viewer).filter((f) => {
      const r = f.getBoundingClientRect();
      return (
        r.width > 0 &&
        r.height > 0 &&
        x >= r.left &&
        x <= r.right &&
        y >= r.top &&
        y <= r.bottom
      );
    });
    return hits.length ? hits[hits.length - 1] : null;
  }

  function resolveFigure(e, root) {
    const viewer = root.querySelector(VIEWER_SEL);
    if (!viewer) return null;

    const fromTarget = e.target.closest?.(FIG_SEL);
    if (fromTarget && viewer.contains(fromTarget)) return fromTarget;

    return figureAtPoint(viewer, e.clientX, e.clientY);
  }

  function initZoomClick(root) {
    if (root.__pgZoomClickInited) return;
    if (!root.querySelector(EXPAND_SEL)) return;
    root.__pgZoomClickInited = true;

    root.addEventListener(
      "click",
      (e) => {
        if (e.target.closest?.(IGNORE_SEL)) return;
        if (
          !e.target.closest?.(VIEWER_SEL) &&
          !e.target.closest?.(EXPAND_SEL)
        ) {
          return;
        }

        const figure = resolveFigure(e, root);
        if (!figure) return;
        if ((figure.dataset.mediaType || "").toLowerCase() !== "image") return;

        const idx = parseInt(figure.getAttribute("data-gallery-index"), 10);
        if (!Number.isFinite(idx) || !window.EmpirePG?.goTo) return;

        EmpirePG.goTo(root, idx, { suppressScroll: true });
      },
      true
    );
  }

  function boot(ctx) {
    (ctx || document).querySelectorAll(ROOT_SEL).forEach(initZoomClick);
  }

  document.addEventListener("DOMContentLoaded", () => boot());
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();
